import { FinnLogo } from "@App/Components/atoms/whitelabel/logos/FinnLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the FINN whitelabel.
 * Extends the default configuration with specific settings for FINN.
 */
export const config: Partial<Config> = {
  slug: "finn",
  navbar: {
    logos: {
      left: {
        component: <FinnLogo />,
      },
      right: {
        component: <RepareoLogo />,
      },
    },
  },
  garageList: {
    emptyState: {
      url: "https://www.finn.com",
      callbackUrl: "https://www.finn.com/api/partner/repareo/callback",
    },
  },
};

export default config;
